import { render } from "./TransferReceiptDownloadLinksContainer.vue?vue&type=template&id=75ee1dda"
import script from "./TransferReceiptDownloadLinksContainer.vue?vue&type=script&lang=js"
export * from "./TransferReceiptDownloadLinksContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__